import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const Icon = ({ className, font, size, type }) => {
  let classes = classNames(`icon-${type}`, className)

  if (font === 'ionicons') {
    classes = classNames(`ion-${type}`)
  }

  return (
    <i
      className={classes}
      style={{ fontSize: size }} />
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  font: PropTypes.string,
  size: PropTypes.number,
  type: PropTypes.string
}

export default Icon
